import React, { useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Box, Button, Grid, Typography } from '@material-ui/core'

import {
  BaseDialog,
  DashboardChartPaper,
  DashboardTable,
  DonutChart,
} from 'components'

import theme from 'theme'
import useStyles from './styles'
import constants from 'constants/index'

const TreatmentAgent = ({ isLoading = false, treatmentAgent = {} }) => {
  const [openDialog, setOpenDialog] = useState(false)

  const classes = useStyles()

  const { ALL_AGENT_LABELS, ALL_AGENT_TYPES, TRANSLATED_TYPE } =
    constants.dataTreatmentAgents
  const { TREATMENT_AGENTS_TABLE, DETAILS_TREATMENT_AGENTS_TABLE } =
    constants.dataIntelligence

  const agentValues = ALL_AGENT_TYPES.map(
    (type) =>
      treatmentAgent?.agentTypes?.find((agent) => agent?.agentType === type)
        ?.quantity || 0,
  )

  const agents = treatmentAgent?.agents?.map((agent) => ({
    name: agent?.name,
    agentType: agent?.agentTypes
      ?.map((type) => TRANSLATED_TYPE[type?.agentType] || type?.agentType)
      .join(', '),
    quantity: agent?.agentTypes?.reduce(
      (sum, type) => sum + (type?.quantity || 0),
      0,
    ),
  }))

  const detailedAgents = treatmentAgent?.agents?.map((agent) => ({
    name: agent.name,
    ...ALL_AGENT_TYPES.reduce((acc, type) => {
      acc[type] =
        agent.agentTypes?.find((t) => t.agentType === type)?.quantity || 0
      return acc
    }, {}),
  }))

  const handleOpenDialog = () => setOpenDialog((prevState) => !prevState)

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
      <Typography variant="h5" color="primary">
        Agentes de tratamento
      </Typography>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardChartPaper
            title="Agentes de tratamento por categoria"
            subtitle="Distribuição dos agentes de tratamento conforme suas categorias"
            isLoading={isLoading}
          >
            <DonutChart
              legendShow
              names={ALL_AGENT_LABELS}
              values={agentValues}
              title="Agentes de tratamento por categoria"
              colors={[
                theme.palette.tertiary.main,
                theme.palette.dashboard.chart.primary.pending,
                theme.palette.dashboard.chart.primary.inProgress,
                theme.palette.dashboard.chart.primary.revision,
              ]}
              showName={false}
            />
          </DashboardChartPaper>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardTable
            emptyMessage="Nenhum agente encontrado."
            rows={agents}
            columns={TREATMENT_AGENTS_TABLE}
            isLoading={isLoading}
            hasPaper
            noWrap
            tableHeadProps={{ className: classes.tableHead }}
          >
            <Box>
              <Button onClick={handleOpenDialog}>Ver Mais</Button>
            </Box>
          </DashboardTable>
        </Grid>
      </Grid>
      <BaseDialog
        open={openDialog}
        setOpen={setOpenDialog}
        title="Detalhes de agentes de tratamento por empresa"
        dialogSize="md"
        closeButtonText="Fechar"
        fullWidth
      >
        <Box>
          <DashboardTable
            emptyMessage="Nenhuma categoria de titular encontrada."
            rows={detailedAgents}
            columns={DETAILS_TREATMENT_AGENTS_TABLE}
            isLoading={isLoading}
            hasPaper
            containerProps={{ className: classes.container }}
            tableHeadProps={{ className: classes.tableHead }}
          />
        </Box>
      </BaseDialog>
    </Box>
  )
}

TreatmentAgent.propTypes = {
  isLoading: PropTypes.bool,
  treatmentAgent: PropTypes.object,
}

export default TreatmentAgent
